import { AccessTime } from '@mui/icons-material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import CircularProgress from '@mui/material/CircularProgress';
import { Job } from '~/state/atoms/jobAtoms';

interface JobStatusIconProps {
    status: Job['status'];
}

export const JobStatusIcon = ({ status }: JobStatusIconProps) => {
    switch (status) {
        case 'Queued':
            return <AccessTime fontSize="small" color="primary" />;
        case 'Uploading':
        case 'Received':
        case 'Processing':
        case 'Downloading':
        case 'RetryDownload':
            return <CircularProgress size={18} />;
        case 'Done':
            return <CheckCircleIcon fontSize="small" color="success" />;
        case 'Error':
        case 'Canceled':
            return <ErrorIcon fontSize="small" color="error" />;
        default:
            return null;
    }
};
